import React from 'react';

import { useSelector } from 'react-redux';

import { createStackNavigator } from '@react-navigation/stack';

import { selectNavigationMenu } from 'store/railsBuilder/selectors';

import RootScreenNavigator from '../RootScreenNavigator';
import { SCREEN } from '../screens';
import { RootTemplates, TEMPLATE_TO_ROUTE } from '../types';

const Stack = createStackNavigator();

const tabScreenOptions = {
    headerLeft: () => null,
    headerTitle: '',
    headerRight: () => null,
    headerStyle: {
        height: 0,
    },
    cardStyle: { flex: 1 },
};

function TabNavigator() {
    const tabs = useSelector(selectNavigationMenu);

    if (!tabs.length) {
        return null;
    }

    return (
        <Stack.Navigator initialRouteName={SCREEN.HOME}>
            {tabs.map((tab) => {
                const routeName = TEMPLATE_TO_ROUTE[tab.name as RootTemplates];

                if (routeName) {
                    return (
                        <Stack.Screen
                            key={tab.id}
                            name={routeName}
                            initialParams={{ id: tab.id }}
                            // @ts-ignore
                            component={RootScreenNavigator}
                            options={tabScreenOptions}
                        />
                    );
                }

                return undefined;
            })}
        </Stack.Navigator>
    );
}

export default TabNavigator;
